const initialState = {
	genresLoading: false,
	errors: null,
	genres: [],
};

export default initialState;
